import { DateRange, Label, Select } from 'components';
import dayjs from 'dayjs';
import { useTranslations } from 'next-intl';
import { connect } from 'react-redux';
import { changeFilter } from './_actions';

const TYPES = [
  'request_success',
  'request_ordered',
  'request_failed',
  'request_quoted',
  'callback',
  'callback_failed'
];
const LEVELS = ['info', 'warning', 'error'];

const Filters = ({ filters, changeFilter, children }) => {
  const t = useTranslations();

  const formatDate = (date, which) => {
    switch (which) {
      case 'start':
        return dayjs(date).startOf('day').toISOString();
      case 'end':
        return dayjs(date).endOf('day').toISOString();
    }
  };

  const changeDateRange = ({ startDate, endDate }) => {
    const fromDate = startDate === null ? null : formatDate(new Date(startDate), 'start');
    const toDate = endDate === null ? null : formatDate(new Date(endDate), 'end');

    changeFilter({ fromDate, toDate });
  };

  const { type, level, fromDate, toDate } = filters;
  const types = TYPES ?? [];
  const levels = LEVELS ?? [];

  return (
    <div className="developers__filters">
      <Label>{t('integrations.logs.log.date_range')}</Label>
      <DateRange
        onChange={changeDateRange}
        className="daterange"
        value={{
          startDate: !fromDate ? null : new Date(fromDate),
          endDate: !toDate ? null : new Date(toDate)
        }}
      />

      <div className="filters__group">
        <Label>{t('integrations.logs.log.type')}</Label>
        <ul className="filters__from_to_trio">
          <li>
            <Select
              selectedValue={type}
              onChange={({ value }) => changeFilter({ type: value })}
              options={[
                {
                  value: 'any',
                  label: t('integrations.logs.log.any')
                },
                ...types.map((type) => ({
                  value: type,
                  label: t(`integrations.logs.log.type_names.${type}`)
                }))
              ]}
            />
          </li>
        </ul>
      </div>

      <div className="filters__group">
        <Label>{t('integrations.logs.log.level')}</Label>
        <ul className="filters__from_to_trio">
          <li>
            <Select
              id="level"
              name="level"
              selectedValue={level}
              onChange={({ value }) => changeFilter({ level: value })}
              options={[
                {
                  value: 'any',
                  label: t('integrations.logs.log.any')
                },
                ...levels.map((level) => ({
                  value: level,
                  label: t(`integrations.logs.log.level_names.${level}`)
                }))
              ]}
            />
          </li>
        </ul>
      </div>
      {children}
    </div>
  );
};

export default connect(({ filters }) => ({ filters }), { changeFilter })(Filters);
